export default __webpack_public_path__ + "static/media/vi.9d718266.svg";